import { render, staticRenderFns } from "./ProfileNavigationItem.vue?vue&type=template&id=273553d2&"
import script from "./ProfileNavigationItem.vue?vue&type=script&lang=ts&"
export * from "./ProfileNavigationItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports